module.exports = __webpack_public_path__ + "static/simon-abrams-286276-unsplash-bbdf1a768b9cf3e78ac4cdf87aa8b92f.jpg";